import { useState } from 'react';
/**
 * Custom hook for managing loading states in the application.
 * @returns An object containing loading states and their setters:
 *   - isLoading: boolean indicating general loading state
 *   - setLoadingStatus: function to update general loading state
 *   - retrievalLoading: boolean indicating retrieval-specific loading state
 *   - setRetrievalLoading: function to update retrieval loading state
 * @public
 */
export const useLoadingState = () => {
  const [isLoading, setLoadingStatus] = useState(false);
  const [retrievalLoading, setRetrievalLoading] = useState(false);
  const [loadingStatusMessages, setLoadingStatusMessage] = useState([]);
  return {
    isLoading,
    setLoadingStatus,
    retrievalLoading,
    setRetrievalLoading,
    loadingStatusMessages,
    setLoadingStatusMessage
  };
};